import React from "react";
import styles from "./document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Finansebi = () => {
  const clubList = [
    {
      name: "ბრძანება 2025-2026 სასწ.წ. ბიუჯეტი",
      filename: "biujeti2025-26.pdf",
    },
    {
      name: "2024-25 სასწავლო წლის ფინანსური გეგმა",
      filename: "finansi.pdf",
    },
  ];

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    height: "100vh",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>სკოლის ფინანსური მდგომარეობის შესახებ</h1>
        </header>
        <div className={styles.documentsContainer}>
          {clubList.map((doc, index) => (
            <a
              key={index}
              className={styles.documentBox}
              target="_blank"
              rel="noreferrer noopener"
              href={`https://batumi-gimnazia.edu.ge/documents/${doc.filename}`}
            >
              {doc.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
